// removed by extract-text-webpack-plugin
module.exports = {"a_greyboxmessage__error":"GreyBoxMessage__a_greyboxmessage__error___3gWQU","a_greyboxmessage__success":"GreyBoxMessage__a_greyboxmessage__success___2Jaic","a_greyboxmessage":"GreyBoxMessage__a_greyboxmessage___11B-N","isInside":"GreyBoxMessage__isInside___1e-Tm","a_greyboxmessage__icon":"GreyBoxMessage__a_greyboxmessage__icon___MCV68","a_greyboxmessage__text":"GreyBoxMessage__a_greyboxmessage__text___13Ojf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/GreyBoxMessage/GreyBoxMessage.scss
// module id = 547
// module chunks = 0